const selectors = {
  select: "[data-select]",
};

const initSelect = (select) => {
  const input = select.children[0];
  const trigger = select.children[1];
  const optionList = select.children[2];

  const params = new URLSearchParams(document.location.search);
  const value = params.get(input.name);

  const handleClickOutside = (event) => {
    const clickedOutside = !select.contains(event.target);

    if (clickedOutside) {
      select.setAttribute("data-select", "hidden");
      document.removeEventListener("click", handleClickOutside);
    }
  };

  const setActiveOption = (target, isNewEvent) => {
    input.value = target.dataset.value;
    input.setAttribute("value", target.dataset.value);
    input.setAttribute("data-parent", target.dataset.parent);
    select.setAttribute("data-select", "hidden");
    trigger.children[0].textContent = target.dataset.label;

    if (isNewEvent) input.dispatchEvent(new Event("change"));
  };

  const handleClickOption = (event) => {
    if (event.target.parentNode !== optionList) return;
    setActiveOption(event.target, true);
  };

  if (value) {
    const activeOption = [...optionList.children].find((option) => option.dataset.value === value);
    if (activeOption) setActiveOption(activeOption);
  }

  trigger.addEventListener("click", () => {
    select.setAttribute("data-select", select.dataset.select === "hidden" ? "active" : "hidden");
    document.addEventListener("click", handleClickOutside);
  });

  optionList.addEventListener("click", handleClickOption);
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const selectList = document.querySelectorAll(selectors.select);

    selectList?.forEach(initSelect);
  },
  {
    once: true,
  }
);
